var render, staticRenderFns
import script from "./AssetButtonGroupOrange.vue?vue&type=script&lang=js"
export * from "./AssetButtonGroupOrange.vue?vue&type=script&lang=js"
import style0 from "./AssetButtonGroupOrange.vue?vue&type=style&index=0&id=814c5806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814c5806",
  null
  
)

export default component.exports